import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ApplicationsPage from './pages/ApplicationsPage';
import BusinessesPage from './pages/BusinessesPage';
import UsersPage from './pages/UsersPage';
import FraudPage from './pages/FraudPage';
import FinancePage from './pages/FinancePage';
import SettingsPage from './pages/SettingsPage';
import LogsPage from './pages/LogsPage';
import LeaderboardsPage from './pages/LeaderboardsPage';
import MonitoringPage from './pages/MonitoringPage';
import InterventionsPage from './pages/InterventionsPage';
import WebsitePage from './pages/WebsitePage';
import CorporatePage from './pages/CorporatePage';
import PromoPage from './pages/PromoPage';
import NotificationsPage from './pages/NotificationsPage';

// PrivateRoute — redirects to /login if not authenticated
const PrivateRoute = ({ children }) => {
  const { admin, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div style={{ fontSize: 18, color: '#FF6B35' }}>Yüklənir...</div>
      </div>
    );
  }

  return admin ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <PrivateRoute><Layout><DashboardPage /></Layout></PrivateRoute>
          } />
          <Route path="/monitoring" element={
            <PrivateRoute><Layout><MonitoringPage /></Layout></PrivateRoute>
          } />
          <Route path="/interventions" element={
            <PrivateRoute><Layout><InterventionsPage /></Layout></PrivateRoute>
          } />
          <Route path="/applications" element={
            <PrivateRoute><Layout><ApplicationsPage /></Layout></PrivateRoute>
          } />
          <Route path="/businesses" element={
            <PrivateRoute><Layout><BusinessesPage /></Layout></PrivateRoute>
          } />
          <Route path="/users" element={
            <PrivateRoute><Layout><UsersPage /></Layout></PrivateRoute>
          } />
          <Route path="/leaderboards" element={
            <PrivateRoute><Layout><LeaderboardsPage /></Layout></PrivateRoute>
          } />
          <Route path="/fraud" element={
            <PrivateRoute><Layout><FraudPage /></Layout></PrivateRoute>
          } />
          <Route path="/finance" element={
            <PrivateRoute><Layout><FinancePage /></Layout></PrivateRoute>
          } />
          <Route path="/settings" element={
            <PrivateRoute><Layout><SettingsPage /></Layout></PrivateRoute>
          } />
          <Route path="/logs" element={
            <PrivateRoute><Layout><LogsPage /></Layout></PrivateRoute>
          } />
          <Route path="/website" element={
            <PrivateRoute><Layout><WebsitePage /></Layout></PrivateRoute>
          } />
          <Route path="/corporate" element={
            <PrivateRoute><Layout><CorporatePage /></Layout></PrivateRoute>
          } />
          <Route path="/promo" element={
            <PrivateRoute><Layout><PromoPage /></Layout></PrivateRoute>
          } />
          <Route path="/notifications" element={
            <PrivateRoute><Layout><NotificationsPage /></Layout></PrivateRoute>
          } />

          {/* Redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
